import { useEffect, useMemo, useState } from "react";
import fallback from "@insightfulscience/shared-utils/async/fallback";

/**
 * Catches the action exception and re-raizes
 * it into the React rendering context
 *
 * @type {<A extends any[], R>(action: (...args: A) => R) => (...args: A) => R}
 */
function useActionError(action) {
	const [error, setError] = useState(null);

	useEffect(() => {
		if (error) throw error;
	}, [error]);

	return useMemo(
		() => fallback(setError)(action),
		[action], // dependencies
	);
}

export default useActionError;
